import React from "react";

import cx from "classnames";

import { Button } from "~/ui";

import type { ThumbValue } from "../FormInputs";
import { ReactComponent as Icon } from "./IconUp.svg";

import stylesIconButton from "~/ui/legacy/IconButton/css/IconButton.module.css";

import styles from "./Button.module.css";

export function ThumbsIcon({ value, className }: { value: ThumbValue; className?: string }) {
	return <Icon className={cx(styles.thumbsIcon, className, { [styles.down]: value === "down" })} />;
}

export default function ThumbsButton({
	value,
	onClick,
	className,
	iconClassName,
}: {
	value: ThumbValue;
	onClick: () => void;
	className?: string;
	iconClassName?: string;
}) {
	return (
		<Button
			size="normal"
			variant="tertiary"
			className={cx(styles.thumbsButton, stylesIconButton.button, className)}
			onClick={onClick}
		>
			<ThumbsIcon value={value} className={iconClassName} />
		</Button>
	);
}
